import { fromJS, List, Map } from 'immutable'
import React, { Fragment, useEffect, useState } from 'react'
import { tokenApi } from '../common/api'
import Table from '../common/table'

export default function ConsentList(props) {
  let { interviewId, token, t } = props

  let [loading, setLoading] = useState(false)
  let [error, setError] = useState(false)
  let [consents, setConsents] = useState(List())

  useEffect(() => {
    setLoading(true)
    tokenApi.get(token, `/dashboard/content/consent/${interviewId}`).then(({ data }) => {
      if (data.success) {
        setConsents(fromJS(data.items || []))
      } else {
        setError(true)
      }

      setLoading(false)
    })
  }, [interviewId])

  let columns = [
    {
      key: 'variables.__inline_user',
      label: t('content.consent.name'),
    },
    {
      key: 'created_at',
      label: t('content.consent.date'),
      width: 200,
      align: 'center',
      date: 'LLL',
    },
  ]

  return (
    <div className="content-consent-list-wrapper">
      {loading || !List.isList(consents) ? (
        <div className="loader">
          <i className="fa fa-spin fa-spinner" />
        </div>
      ) : error ? (
        <div className="message message--error">{t('content.consent.error')}</div>
      ) : consents.size ? (
        <Fragment>
          <div className="content-consent-list-title">
            <h2>{t('content.consent.title')}</h2>
          </div>
          <div className="page-view">
            <div className="page-view-table">
              <Table rows={consents} columns={columns} id="id" />
            </div>
          </div>
        </Fragment>
      ) : null}
    </div>
  )
}
